import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PropTypes from 'prop-types'; // Recommended for type checking props

// Assuming the API base URL is needed for images
const API_BASE_URL = process.env.REACT_APP_API_URL;

const Banner = ({ bannerImages = [], heading = "Loading..." }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3500,
    arrows: false,
  };

  if (bannerImages.length === 0) {
    return null;
  }

  return (
    <section className="research_banner_section">
      <Slider {...settings} className="banner-carousel">
        {bannerImages.map((img, index) => (
          <div key={index} className="item">
            {/* Construct the full image URL using the API base URL */}
            <img src={`${API_BASE_URL}/public/${img}`} alt={`${heading} Banner ${index + 1}`} />
          </div>
        ))}
      </Slider>
      <div className="breadcrump-wrapper">
        <h4 className="breadcrump-heading">{heading}</h4>
      </div>
    </section>
  );
};

Banner.propTypes = {
    bannerImages: PropTypes.arrayOf(PropTypes.string),
    heading: PropTypes.string,
};

export default Banner;